import { render } from "./MasterDataColumnsView.vue?vue&type=template&id=49499353&scoped=true&ts=true"
import script from "./MasterDataColumnsView.vue?vue&type=script&lang=ts"
export * from "./MasterDataColumnsView.vue?vue&type=script&lang=ts"

import "./MasterDataColumnsView.vue?vue&type=style&index=0&id=49499353&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49499353"]])

export default __exports__